export default "__VITE_PUBLIC_ASSET__ad71bcd4__"